import React from 'react';
import classNames from 'classnames';

import './widget-carousel-desktop-basic.scss';

const WidgetCarouselDesktopBasic: React.FC<any> = props => (
    <div className="react-multi-carousel-list w-carousel-d__list">
        <ul className="react-multi-carousel-track ">
            {
                React.Children.map(props.children, (child, index) => (
                    <li
                        className={classNames({
                            'react-multi-carousel-item': true,
                            'w-carousel-d__list__item': true,
                            [`h-${props.slidesToSlide}`]: true,
                            [String(props.itemClass)]: true,
                            'd-block': index === 0
                        })}
                    >
                        {child}
                    </li>
                ))
            }
        </ul>
    </div>
);

export default WidgetCarouselDesktopBasic;
